import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule, OnInit } from '@angular/core';

import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { 
    path: 'pages',
    loadChildren: 'app/pages/pages.module#PagesModule',
    canActivate: [AuthGuard]
  },
  { path: 'intro', loadChildren: 'app/intro/intro.module#IntroModule' },
  { path: 'segunda-via', loadChildren: 'app/segunda-via/segunda-via.module#SegundaViaModule' },
  { path: 'renegociacao', loadChildren: 'app/renegociacao/renegociacao.module#RenegociacaoModule' },
  { 
    path: 'status-venda', 
    loadChildren: 'app/status-venda/status-venda.module#StatusVendaModule',
  },
  { path: 'confirm', loadChildren: 'app/confirm/confirm.module#ConfirmModule' },
  { path: 'auth', loadChildren: 'app/auth/auth.module#AuthModule' },
  { path: 'contratos', loadChildren: 'app/pages/contratos/contratos.module#ContratosModule' },
  { path: 'convite', loadChildren: 'app/indicacao/indicacao.module#IndicacaoModule' },
  { path: '', redirectTo: 'auth/signin', pathMatch: 'full' },
  { path: '**', redirectTo: 'auth/signin' },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule implements OnInit {
  constructor(
    private guard: AuthGuard
  ) {}

  ngOnInit() {}
}


// WEBPACK FOOTER //
// /var/www/minha-at3-cliente/src/app/app-routing.module.ts